import React from 'react';

import StandardButton from '../../components/StandardButton/StandardButton';
import InfoButton from '../../components/InfoButton/InfoButton';
import ImageButton from '../../components/ImageButton/ImageButton';
import './CampaignFinance.css';


const CampaignFinance = () => (
  <div className="page-container campaign-finance">
    <h2 className="vr-header">Campaign Finance</h2>
    <p className="intro">Welcome to Ohio’s Data Portal, your gateway to comprehensive and interactive 
      information directly sourced from the Ohio Secretary of State's website. The Campaign Finance 
      page offers detailed financial data on political campaigns, giving you transparency into how 
      elections are funded. Explore these comprehensive tools today to empower your participation in 
      these vital areas.
    </p>

    {/* First Section */}
    <section className="section">
      <h3 className="section-title">Simple Search</h3>
      <div className="summary-row">
        <div className="summary-text">
          <p>
            Search, view, and download campaign finance
            data files with the Secretary of State’s office. Information will be provided within five days of an entity filing.
          </p>
        </div>
        <a
          href="https://www6.ohiosos.gov/ords/f?p=CFDISCLOSURE:1:15708183177066::NO::::"
          target="_blank"
          rel="noopener noreferrer"
          className="standard-btn-link"
        >
          <button className="standard-btn search-btn">Search</button>
        </a>
      </div>
    </section>

    {/* Second Section */}
    <section className="section">
      <h3 className="section-title">Advanced Search</h3>
      <div className="summary-text">
        <p>Search the database on multiple criterea </p>
      </div>
      <div className="standard-button-row">
        <StandardButton
          label="Committee"
          href="https://www6.ohiosos.gov/ords/f?p=CFDISCLOSURE:35:::NO:RP,35::"
        />
        <StandardButton
          label="Cover Page"
          href="https://www6.ohiosos.gov/ords/f?p=CFDISCLOSURE:4:::NO:RP,4::"
        />
        <StandardButton
          label="Contributions"
          href="https://www6.ohiosos.gov/ords/f?p=CFDISCLOSURE:2:::NO:RP,2::"
        />
        <StandardButton
          label="Expenditures"
          href="https://www6.ohiosos.gov/ords/f?p=CFDISCLOSURE:3:::NO:RP,3::"
        />
      </div>
    </section>

    {/* Third Section */}
    <section className="section">
      <h3 className="section-title">File Transfer Page</h3>
      <div className="summary-text">
        <p>The Campaign Finance File Transfer Page allows users to obtain large sets of data faster than the normal query
          process. Additionally, data filed prior to 2000 is available on this site. </p>
      </div>
      <div className="standard-button-row">
        <StandardButton
          label="New Files"
          href="https://www6.ohiosos.gov/ords/f?p=CFDISCLOSURE:73:15708183177066:NEW:NO:RP:P73_TYPE:NEW:"
        />
        <StandardButton
          label="Candidate Files"
          href="https://www6.ohiosos.gov/ords/f?p=CFDISCLOSURE:73:15708183177066:CAN:NO:RP:P73_TYPE:CAN:"
        />
        <StandardButton
          label="PAC Files"
          href="https://www6.ohiosos.gov/ords/f?p=CFDISCLOSURE:73:15708183177066:PAC:NO:RP:P73_TYPE:PAC:"
        />
        <StandardButton
          label="Party Files"
          href="https://www6.ohiosos.gov/ords/f?p=CFDISCLOSURE:73:15708183177066:PARTY:NO:RP:P73_TYPE:PARTY:"
        />
      </div>

    </section>


  </div>
);

export default CampaignFinance;
